export { CreateNewPage } from './CreateNewPage';
